import { Link } from 'react-router-dom';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';

import { MissionKindEnum } from '@e-socna/data-layer';
import type { MissionStateId } from '@e-socna/data-layer';

import { PATH_MISSION_DEFAULT } from '../../app/constants/paths.constant';
import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { FolderBusinessEntityListCmp_FolderBusinessEntity } from './fragments/folder-business-entity.fragment';
import { buildMissionPath } from '../../app/utils/mission-space.util';

type SubMissions = Extract<
  FolderBusinessEntityListCmp_FolderBusinessEntity,
  { __typename: 'Mission' }
>['subMissions'];

interface Props {
  readonly subMissions: SubMissions;
}

export const SubMissionsTree = ({ subMissions }: Readonly<Props>) => {
  const { missionStatesIdMap } = useReferencesContext();

  return (
    <>
      <Typography gutterBottom variant="overline">
        Sous-Missions
      </Typography>
      {subMissions.length ? (
        <List dense disablePadding>
          {subMissions.map((subMission) => (
            <ListItemButton
              component={Link}
              key={subMission._id}
              to={buildMissionPath(PATH_MISSION_DEFAULT, {
                folderId: subMission.folderId,
                missionId: subMission._id,
                kind: MissionKindEnum.SubMission,
                compositeMissionId: subMission.compositeMissionId,
              })}
            >
              <ListItemIcon>
                <SubdirectoryArrowRightIcon />
              </ListItemIcon>
              <ListItemText
                primary={subMission.code}
                secondary={`${subMission.consolidation.title} - ${
                  missionStatesIdMap[subMission.stateId as MissionStateId]
                    ?.label ?? ''
                }`}
              />
            </ListItemButton>
          ))}
        </List>
      ) : (
        <Typography gutterBottom variant="body2">
          Aucune mission
        </Typography>
      )}
    </>
  );
};
